module.exports = __webpack_public_path__ + "static/media/tools-slider-img2.1d0079ac.png";